import 'firebase/auth';
import 'firebase/database';

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';

const config = {
  apiKey: 'AIzaSyBRCO0wXb3yG_I41B0ofVNCeNgHzZASKRw',
  appId: '1:1036402175377:web:cfc88f2f43f258e5d3be30',
  authDomain: 'englishstarsoutez.firebaseapp.com',
  databaseURL:
    'https://englishstarsoutez-default-rtdb.europe-west1.firebasedatabase.app',
  measurementId: 'G-V06160M5NL',
  messagingSenderId: '1036402175377',
  projectId: 'englishstarsoutez',
  storageBucket: 'englishstarsoutez.appspot.com',
};

initializeApp(config);

export const auth = getAuth();
export const database = getDatabase();
